module.exports = __webpack_public_path__ + "static/img/sl.ddbd1d9b.svg";